import "./App.css";
import "./input.css";
import UploadPortal from "./pages/fileUpload/uploadPortal";
import Login from "./pages/login/login";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { ThemeProvider } from "./components/theme-provider";

const router = createBrowserRouter([
  { path: "/", element: <Login /> },
  { path: "/dicom", element: <UploadPortal /> },
  { path: "*", element: <Login /> }
]);
function App() {
  return (
    <ThemeProvider>
      <RouterProvider router={router} />
    </ThemeProvider>
  );
}

export default App;
